import { useCallback, useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOperationGetOrderByIdLazyQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseOperationOrderEntity } from 'api/helpers/operation';

export const useOperationGetOrderByIdLazy = () => {
  const [getOperationOrder, { data, loading, error: apolloError }] =
    useOperationGetOrderByIdLazyQuery();

  const error = useError(apolloError);

  const operationOrder = useMemo(
    () =>
      data?.operationOrder
        ? parseOperationOrderEntity(data.operationOrder)
        : null,
    [data]
  );

  const handleGetOperationOrder = useCallback(
    async (orderId: string) => {
      const res = await getOperationOrder({ variables: { orderId } });
      if (res.data?.operationOrder) {
        return parseOperationOrderEntity(res.data.operationOrder);
      }
      return null;
    },
    [getOperationOrder]
  );

  return {
    operationOrder,
    loading,
    error,
    getOperationOrder: handleGetOperationOrder,
  };
};
